import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axiosInstance from '../../main/axios';
import Button from '../../common/form/button';
import { confirmarFinalizarOs, fecharFinalizarOs } from './ordemServicoActions';

const OPCOES = [
  {
    value: 'FINALIZADA',
    label: 'Finalizada',
    descricao: 'Serviço concluído com sucesso',
    icon: 'check-circle',
    modifier: 'is-finalizada',
  },
  {
    value: 'CANCELADA',
    label: 'Cancelada',
    descricao: 'OS encerrada sem conclusão',
    icon: 'ban',
    modifier: 'is-cancelada',
  },
];

function materiaisComSaldo(materiais) {
  return (materiais || [])
    .map(m => {
      const quantidade_restante =
        parseFloat(m.quantidade) - parseFloat(m.quantidade_devolvida || 0);
      return { ...m, quantidade_restante };
    })
    .filter(m => m.quantidade_restante > 0);
}

class OrdemServicoFinalizarModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      devolverEstoque: null,
      materiais: [],
      carregandoMateriais: false,
    };
    this.handleConfirmar = this.handleConfirmar.bind(this);
    this.handleFechar = this.handleFechar.bind(this);
    this.handleSelecionar = this.handleSelecionar.bind(this);
    this.handleDevolverEstoque = this.handleDevolverEstoque.bind(this);
    this.carregarMateriais = this.carregarMateriais.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.resetarEstado();
      this.carregarMateriais();
      return;
    }

    if (this.props.show && this.props.os && prevProps.os && this.props.os.id !== prevProps.os.id) {
      this.resetarEstado();
      this.carregarMateriais();
    }
  }

  resetarEstado() {
    this.setState({ status: '', devolverEstoque: null, materiais: [], carregandoMateriais: false });
  }

  carregarMateriais() {
    const { os } = this.props;
    if (!os || !os.id) return;

    this.setState({ carregandoMateriais: true });
    axiosInstance
      .get(`/manutencao/ordens_servico/${os.id}/materiais`)
      .then(resp => {
        this.setState({
          materiais: resp.data || [],
          carregandoMateriais: false,
        });
      })
      .catch(() => {
        this.setState({ materiais: [], carregandoMateriais: false });
      });
  }

  handleSelecionar(status) {
    this.setState(prev => ({
      status,
      devolverEstoque: status === 'CANCELADA' ? prev.devolverEstoque : null,
    }));
  }

  handleDevolverEstoque(devolverEstoque) {
    this.setState({ devolverEstoque });
  }

  handleFechar() {
    this.resetarEstado();
    this.props.fecharFinalizarOs();
  }

  handleConfirmar() {
    const { status, devolverEstoque } = this.state;
    const { confirmando } = this.props;
    const materiaisSaldo = materiaisComSaldo(this.state.materiais);
    const precisaEscolherEstoque = status === 'CANCELADA' && materiaisSaldo.length > 0;

    if (!status || confirmando) return;
    if (precisaEscolherEstoque && devolverEstoque === null) return;

    const opcoes =
      precisaEscolherEstoque && devolverEstoque === true ? { devolver_estoque: true } : {};

    this.props.confirmarFinalizarOs(status, opcoes);
  }

  render() {
    const { show, os, confirmando } = this.props;
    const { status, devolverEstoque, materiais, carregandoMateriais } = this.state;
    const materiaisSaldo = materiaisComSaldo(materiais);
    const exibirPerguntaEstoque = status === 'CANCELADA' && materiaisSaldo.length > 0;
    const podeConfirmar =
      !!status &&
      !confirmando &&
      (!exibirPerguntaEstoque || devolverEstoque !== null);

    return (
      <Modal show={show} onHide={this.handleFechar} backdrop="static" dialogClassName="os-finalizar-modal-dialog">
        <div className="os-excel-modal-shell">
          <div className="os-excel-modal-header">
            <div className="os-excel-modal-header-main">
              <div className="os-excel-modal-header-icon">
                <i className="fa fa-flag-checkered" />
              </div>
              <div>
                <h4>Finalizar ordem de serviço</h4>
                <p>Selecione como deseja encerrar esta OS.</p>
              </div>
            </div>
            <button type="button" className="os-excel-modal-close" onClick={this.handleFechar} aria-label="Fechar">
              <i className="fa fa-times" />
            </button>
          </div>

          <div className="os-excel-modal-body os-finalizar-modal-body">
            {os ? (
              <div className="os-finalizar-resumo">
                <span className="os-finalizar-resumo-numero">{os.numero}</span>
                <span className="os-finalizar-resumo-titulo">{os.titulo || 'Sem título'}</span>
              </div>
            ) : null}

            <p className="os-finalizar-modal-label">Forma de encerramento</p>
            <div className="os-finalizar-opcoes">
              {OPCOES.map(opcao => (
                <button
                  key={opcao.value}
                  type="button"
                  className={`os-finalizar-opcao ${opcao.modifier} ${status === opcao.value ? 'is-selected' : ''}`}
                  onClick={() => this.handleSelecionar(opcao.value)}
                >
                  <span className="os-finalizar-opcao-icon">
                    <i className={`fa fa-${opcao.icon}`} />
                  </span>
                  <span className="os-finalizar-opcao-texto">
                    <strong>{opcao.label}</strong>
                    <small>{opcao.descricao}</small>
                  </span>
                  <span className="os-finalizar-opcao-check">
                    <i className="fa fa-check" />
                  </span>
                </button>
              ))}
            </div>

            {exibirPerguntaEstoque ? (
              <div className="os-finalizar-estoque-panel">
                <div className="os-finalizar-estoque-panel-header">
                  <i className="fa fa-boxes" />
                  <div>
                    <strong>Estoque vinculado à OS</strong>
                    <p>Esta OS possui materiais aplicados com saldo não devolvido.</p>
                  </div>
                </div>

                {carregandoMateriais ? (
                  <p className="os-finalizar-estoque-loading">
                    <i className="fa fa-spinner fa-spin" /> Carregando materiais...
                  </p>
                ) : (
                  <ul className="os-finalizar-estoque-lista">
                    {materiaisSaldo.map(m => (
                      <li key={m.id}>
                        <span>{m.item_descricao}</span>
                        <strong>
                          {m.quantidade_restante} {m.item_unidade}
                        </strong>
                      </li>
                    ))}
                  </ul>
                )}

                <p className="os-finalizar-modal-label">Devolver estoque ao cancelar?</p>
                <div className="os-finalizar-estoque-opcoes">
                  <button
                    type="button"
                    className={`os-finalizar-estoque-opcao ${devolverEstoque === true ? 'is-selected' : ''}`}
                    onClick={() => this.handleDevolverEstoque(true)}
                  >
                    <i className="fa fa-undo" />
                    <span>
                      <strong>Sim, devolver</strong>
                      <small>Retorna o saldo ao estoque</small>
                    </span>
                  </button>
                  <button
                    type="button"
                    className={`os-finalizar-estoque-opcao ${devolverEstoque === false ? 'is-selected' : ''}`}
                    onClick={() => this.handleDevolverEstoque(false)}
                  >
                    <i className="fa fa-times-circle" />
                    <span>
                      <strong>Não devolver</strong>
                      <small>Mantém a saída registrada</small>
                    </span>
                  </button>
                </div>
              </div>
            ) : null}
          </div>

          <div className="os-excel-modal-footer">
            <Button
              type="button"
              className="default"
              icon="close"
              label="Cancelar"
              onClick={this.handleFechar}
              disabled={confirmando}
            />
            <button
              type="button"
              className="btn btn-primary os-excel-modal-action-btn"
              onClick={this.handleConfirmar}
              disabled={!podeConfirmar}
            >
              {confirmando ? (
                <>
                  <i className="fa fa-spinner fa-spin" /> Confirmando...
                </>
              ) : (
                <>
                  <i className="fa fa-check" /> Confirmar
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  show: !!(state.manutencaoOS && state.manutencaoOS.finalizarModalOs),
  os: state.manutencaoOS && state.manutencaoOS.finalizarModalOs,
  confirmando: !!(state.manutencaoOS && state.manutencaoOS.finalizarModalConfirmando),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ fecharFinalizarOs, confirmarFinalizarOs }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrdemServicoFinalizarModal);
